import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";
import GoogleCredentialsTab from "../Credentials/GoogleCredentials";
import PlentyCredentialsTab from "../Credentials/PlentyCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`credentials-tabpanel-${index}`}
    aria-labelledby={`credentials-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const CredentialsTab = () => {
  const [credentialsSubTab, setCredentialsSubTab] = useState(0);

  const handleCredentialsSubTabChange = (event, newValue) => {
    setCredentialsSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={credentialsSubTab}
              onChange={handleCredentialsSubTabChange}
              aria-label="credentials tabs"
            >
              <Tab label="Google Credentials" />
              <Tab label="Plenty Credentials" />
            </Tabs>
          </Box>

          {/* Google Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={0}>
            <GoogleCredentialsTab />
          </TabPanel>

          {/* Plenty Credentials Tab */}
          <TabPanel value={credentialsSubTab} index={1}>
            <PlentyCredentialsTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CredentialsTab;
